import React from "react";
import ProfileBanner from "../../shared/utilities/ProfileBanner";

const TransporterCompany = props => {
  const { companyAddress } = props;

  return (
    <ProfileBanner title="Company Address">
      <div>{companyAddress[0].TRANS_NAME}</div>
      <div>{companyAddress[0].TRANS_STR1}</div>
      <div>
        {companyAddress[0].TRANS_CITY}, {companyAddress[0].TRANS_ST}{" "}
        {companyAddress[0].TRANS_ZIP}
      </div>
    </ProfileBanner>
  );
};

export default TransporterCompany;
